import { GraphqlExplorerPage } from '@squareup/dex-feature-dex-tech-main-graphql-explorer-page';
import { Head } from '@squareup/dex-ui';
import {
  getNextPublicGraphqlExplorerNameOrDefault,
  getNextPublicSquareDocsURL,
} from '@squareup/dex-utils-environment';
import React from 'react';

import ExplorerBasePage from '../../shared/ExplorerBasePage';
import { graphqlExplorerGetInitialProps } from '../../shared/explorer-get-initial-props';

const PageContent = () => {
  return (
    <>
      <Head
        description=""
        preconnectUrl={getNextPublicSquareDocsURL()}
        title={getNextPublicGraphqlExplorerNameOrDefault()}
      />
      <GraphqlExplorerPage />
    </>
  );
};

const Page = () => {
  return (
    <ExplorerBasePage searchDomain="docs">
      <PageContent />
    </ExplorerBasePage>
  );
};

Page.getInitialProps = graphqlExplorerGetInitialProps;

export default Page;
